<!--<template>-->
<!--    <div>-->
<!--        <v-menu v-model="menu"-->
<!--                :close-on-content-click="false"-->
<!--                full-width>-->
<!--            <template v-slot:activator="{ on }">-->
<!--                <v-text-field-->
<!--                        label="项目类型"-->
<!--                        readonly-->
<!--                        v-model="text"-->
<!--                        append-icon="search"-->
<!--                        clearable-->
<!--                        @click:append="menu = !menu"-->
<!--                        v-on="on">-->
<!--                </v-text-field>-->
<!--            </template>-->

<!--            <v-card>-->
<!--                <v-treeview-->
<!--                        v-model="selected"-->
<!--                        :items="items"-->
<!--                        item-key="dbid"-->
<!--                        activatable-->
<!--                        active-class="grey lighten-4 indigo&#45;&#45;text"-->
<!--                        selected-color="indigo"-->
<!--                        open-on-click-->
<!--                        selectable-->
<!--                        return-object-->
<!--                />-->
<!--            </v-card>-->
<!--        </v-menu>-->
<!--    </div>-->
<!--</template>-->
<!--<script>-->
<!--    const typeTreeUri = '/api/proj/project-type/get/tree';-->

<!--    export default {-->
<!--        name: 'ProjTpeTree',-->
<!--        model: {-->
<!--            prop: 'values', // 选中的树节点的 dbid-->
<!--            event: 'input'-->
<!--        },-->
<!--        props: ["values"],-->

<!--        data: () => ({-->
<!--            menu: false,-->

<!--            items: [], // 树节点-->
<!--            selected: [],  // 选中的树节点-->
<!--        }),-->

<!--        created() {-->
<!--            const vm = this;-->
<!--            this.axios.get(typeTreeUri).then(rsp => {-->
<!--                vm.items = rsp.data.items;-->

<!--                if (Array.isArray(vm.values)) {-->
<!--                    // window.console.log(vm.values);-->
<!--                    vm.selected = vm.getNodes(vm.values);-->
<!--                    //window.console.log(vm.selected)-->
<!--                }-->
<!--            })-->

<!--        },-->
<!--        watch: {-->
<!--            selected(nv) {-->
<!--                const val = (nv || []).filter(v => v.leaf).map(v => v.dbid);-->
<!--                this.$emit('input', val);-->
<!--            }-->
<!--        },-->
<!--        computed: {-->
<!--            text: {-->
<!--                get() {-->
<!--                    const vals = [];-->

<!--                    const parentIsSelected = (p) => {-->
<!--                        for (const n of this.selected) {-->
<!--                            if (n.dbid === p.parentId) return true;-->
<!--                        }-->
<!--                        return false;-->
<!--                    };-->

<!--                    for (const n of this.selected) {-->
<!--                        if (!parentIsSelected(n)) vals.push(n);-->
<!--                    }-->

<!--                    return vals.map(v => v.name).join('; ');-->
<!--                },-->
<!--                set(val) {-->
<!--                    if (!val || val.length === 0)-->
<!--                        this.selected = [];-->
<!--                }-->
<!--            },-->
<!--        },-->
<!--        methods: {-->
<!--            getNodes(ids) {-->
<!--                const get_nodes_by_id = (nodes, ids) => {-->
<!--                    if (Array.isArray(nodes)) {-->
<!--                        let selects = nodes.filter(v => ids.find(e => e === v.dbid));-->
<!--                        nodes.forEach(n => {-->
<!--                            selects = selects.concat(get_nodes_by_id(n.children, ids))-->
<!--                        });-->
<!--                        return selects;-->
<!--                    } else {-->
<!--                        return [];-->
<!--                    }-->
<!--                };-->

<!--                return get_nodes_by_id(this.items, ids);-->
<!--            }-->
<!--        }-->
<!--    }-->
<!--</script>-->

<!--<style>-->

<!--</style>-->

<template>
  <div>
    <v-menu v-model="menu"
            :close-on-content-click="false"
            full-width
    >
      <template v-slot:activator="{ on }">
        <v-text-field
            label="项目类型"
            readonly
            v-model="text"
            append-icon="search"
            clearable
            @click:append="menu = !menu"
            v-on="on">
        </v-text-field>
      </template>

      <v-card
          style="
                max-height: 700px;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
              "
      >
        <!-- 新增搜索框 -->
        <v-text-field
            v-model="searchText"
            label="搜索类别"
            clearable
            dense
            class="px-4 pt-4"
            @click:clear="clearSearch"
            prepend-inner-icon="mdi-magnify"
        ></v-text-field>

        <v-treeview
            v-model="selected"
            :items="filteredItems"
            item-key="dbid"
            activatable
            active-class="grey lighten-4 indigo--text"
            selected-color="indigo"
            open-on-click
            selectable
            return-object
            :search="searchText"
        />
      </v-card>
    </v-menu>
  </div>
</template>
<script>
const typeTreeUri = '/api/proj/project-type/get/tree';

export default {
  name: 'ProjTpeTree',
  model: {
    prop: 'values', // 选中的树节点的 dbid
    event: 'input'
  },
  props: ["values"],

  data: () => ({
    menu: false,
    searchText: '',  // 搜索关键词
    items: [], // 原始树节点
    selected: [],  // 选中的树节点
  }),

  created() {
    const vm = this;
    this.axios.get(typeTreeUri).then(rsp => {
      vm.items = rsp.data.items;
      markLeaf(vm.items);
      vm.originalItems = JSON.parse(JSON.stringify(vm.items));
      // 深拷贝原始数据用于搜索过滤
      vm.originalItems = JSON.parse(JSON.stringify(rsp.data.items));

      if (Array.isArray(vm.values)) {
        vm.selected = vm.getNodes(vm.values);
      }
    })

    function markLeaf(nodes) {
      if (!nodes) return;
      for (const node of nodes) {
        if (!node.children || node.children.length === 0) {
          node.leaf = true;
        } else {
          node.leaf = false;
          markLeaf(node.children);
        }
      }
    }
  },
  watch: {
    selected(nv) {
      const val = (nv || []).filter(v => v.leaf).map(v => v.dbid);
      this.$emit('input', val);
    },
  },
  computed: {
    text: {
      get() {
        // 只显示选中的叶子节点名称
        return this.selected
            .filter(node => node.leaf)
            .map(node => node.name)
            .join('; ');
      },
      set(val) {
        if (!val || val.length === 0)
          this.selected = [];
      }
    },
    // 计算属性：过滤后的树节点
    filteredItems() {
      if (!this.searchText) return this.items;
      return this.filterTree(this.originalItems, this.searchText.toLowerCase());
    }
  },
  methods: {
    // 递归过滤树节点：保留匹配节点及其所有祖先
    filterTree(nodes, keyword) {
      if (!nodes || nodes.length === 0) return [];

      return nodes
          .map(node => {
            // 递归处理子节点
            const children = node.children || [];
            const filteredChildren = this.filterTree(children, keyword);

            // 检查当前节点是否匹配
            const isMatch = node.name && node.name.toLowerCase().includes(keyword);

            // 保留条件：当前节点匹配 或 有匹配的子节点
            if (isMatch || filteredChildren.length > 0) {
              return {
                ...node,
                children: filteredChildren.length > 0 ? filteredChildren : []
              };
            }
            return null;
          })
          .filter(Boolean); // 移除null值
    },

    getNodes(ids) {
      const get_nodes_by_id = (nodes, ids) => {
        if (!nodes) return [];

        let selects = [];
        for (const node of nodes) {
          if (ids.includes(node.dbid)) {
            selects.push(node);
          }
          if (node.children) {
            selects = selects.concat(get_nodes_by_id(node.children, ids));
          }
        }
        return selects;
      };

      return get_nodes_by_id(this.items, ids);
    },

    // 清空搜索
    clearSearch() {
      this.searchText = ''; // ✅ 只需清空 searchText，filteredItems 会自动更新
    },


  }
}
</script>

<style scoped>
/* 优化搜索框样式 */
.v-text-field--dense {
  padding-top: 0 !important;
}
</style>
